import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const SimilarQuestions = ({ userId, currentQuestion, onSelectQuestion }) => {
  const [similarQuestions, setSimilarQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!currentQuestion || currentQuestion.trim() === "") return;

    const fetchSimilarQuestions = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${
            process.env.REACT_APP_API_URL
          }/ai/similar-questions?userId=${userId}&question=${encodeURIComponent(
            currentQuestion
          )}`
        );

        if (response.ok) {
          const data = await response.json();
          setSimilarQuestions(data);
        }
      } catch (error) {
        console.error("Error fetching similar questions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSimilarQuestions();
  }, [userId, currentQuestion]);

  if (similarQuestions.length === 0) return null;

  return (
    <Box
      sx={{ mt: 2, mb: 2, border: "1px solid #e0e0e0", borderRadius: 1, p: 1 }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant="subtitle2" color="primary">
          You've asked similar questions before
        </Typography>
        <IconButton size="small">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <List dense>
          {similarQuestions.map((item, index) => (
            <ListItem
              key={index}
              button
              onClick={() => onSelectQuestion(item.question)}
              sx={{
                borderLeft: "2px solid #2196f3",
                pl: 2,
                mb: 1,
                backgroundColor: "#f5f5f5",
                borderRadius: 1,
              }}
            >
              <ListItemText
                primary={item.question}
                secondary={new Date(item.timestamp).toLocaleDateString()}
              />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box>
  );
};

export default SimilarQuestions;
